"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var rxjs_hooks_1 = require("rxjs-hooks");
exports.now = function () { return new Date().getTime(); };
exports.IncrementalSearch = function (_a) {
    var inputValue = _a.inputValue, search = _a.search, onSearched = _a.onSearched, submit$ = _a.submit$, children = _a.children;
    var data = rxjs_hooks_1.useObservable(function (inputValue$) {
        return rxjs_1.merge(inputValue$.pipe(
        // tap(v => console.log('input1', v)),
        operators_1.map(function (v) { return v[0]; }), 
        // tap(v => console.log('input2', v)),
        operators_1.filter(function (v) { return !!v && v.length > 1; }), 
        // tap(v => console.log('input3', v)),
        operators_1.distinctUntilChanged(), 
        // tap(v => console.log('input4', v)),
        operators_1.debounceTime(5000), 
        // tap(v => console.log('input5', v)),
        operators_1.map(function (v) { return ({ value: v, time: exports.now() }); })), submit$.pipe(
        // tap(v => console.log('submit1', v)),
        operators_1.filter(function (v) { return typeof v !== 'undefined'; }), 
        // tap(v => console.log('submit2', v)),
        operators_1.distinctUntilChanged(), 
        // tap(v => console.log('submit3', v)),
        operators_1.map(function () { return ({ value: inputValue$.value[0], time: exports.now() }); }))).pipe(operators_1.distinctUntilChanged(function (a, b) { return a.time === b.time && a.value === b.value; }), operators_1.map(function (v) { return v.value; }), 
        // tap(v => console.log('before query', v)),
        operators_1.switchMap(function (v) { return search(v); }), 
        // tap(v => console.log('after query', v)),
        operators_1.map(function (result) {
            // console.log('result', result, inputValue$.value.join(','))
            if (result) {
                var _a = result.data.queryFAQ, queryFAQ = _a === void 0 ? [] : _a;
                onSearched(inputValue, queryFAQ);
            }
            return result;
        }));
    }, { data: { queryFAQ: [] } }, [inputValue]);
    // console.log(data)
    return children && children(data);
};
//# sourceMappingURL=IncrementalSearch.js.map